import { T, useGT } from 'gt-react';
import { UploadSimpleIcon } from '@phosphor-icons/react';
import { HeaderPageTitle } from 'src/context/header-title.context';
import { Button } from '@/components/ui/button';

export function PurchaseTrendPageHeader({
  canUpload,
  onUploadClick,
}: {
  canUpload: boolean;
  onUploadClick: () => void;
}) {
  const gt = useGT();
  return (
    <div className="mb-2 flex flex-wrap items-start justify-between gap-2">
      <div>
        <HeaderPageTitle>
          {gt('Purchases vs. Rebates', {
            context: 'rebates report page title',
          })}
        </HeaderPageTitle>
        <p className="text-sm text-muted-foreground">
          {gt(
            'Purchases from the file versus supplier purchases and rebate earnings',
            { context: 'rebates report page subtitle' },
          )}
        </p>
      </div>
      {canUpload ? (
        <Button onClick={onUploadClick} data-testid="upload-purchases">
          <UploadSimpleIcon className="mr-2 h-4 w-4" />
          <T context="button to open purchases file upload">Upload Purchases</T>
        </Button>
      ) : null}
    </div>
  );
}
